import { render, staticRenderFns } from "./FeaturedSearch.vue?vue&type=template&id=e27a5622&"
import script from "./FeaturedSearch.vue?vue&type=script&lang=js&"
export * from "./FeaturedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports